var map = {
	"./apple/storage": 554,
	"./isomorphic/storage": 555,
	"./samsung/orsay/storage": 556,
	"./sony/trilithium/storage": 557
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 553;


//////////////////
// WEBPACK FOOTER
// ./src/services/platforms ^\.\/.*\/storage$
// module id = 553
// module chunks = 0